import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Fab } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import * as utils from '@utils'

class RefreshButton extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'RefreshButton')
        }
    }

    render() {
        return (
            <Fab
                style={{
                    width: '36px',
                    height: '36px',
                    margin: '12px',
                    ...this.props.style,
                }}
                color="primary"
                aria-label="add"
                onClick={() => this.props.callback()}>
                <RefreshIcon />
            </Fab>
        )
    }
}

RefreshButton.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    callback: PropTypes.func,
    style: PropTypes.object,
}

const styles = (_theme) => ({})

export default hoc(styles)(RefreshButton)
